import { render, staticRenderFns } from "./DocumentGenerator.vue?vue&type=template&id=7a42479a&scoped=true"
import script from "./DocumentGenerator.vue?vue&type=script&lang=js"
export * from "./DocumentGenerator.vue?vue&type=script&lang=js"
import style0 from "./DocumentGenerator.vue?vue&type=style&index=0&id=7a42479a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a42479a",
  null
  
)

export default component.exports